import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { API, FILTERS } from "@/lib/site";
import { SkinCard } from "@/components/site/SkinCard";
import { Loader2 } from "lucide-react";

export const Skins = () => {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("alle");

  useEffect(() => {
    let active = true;
    setLoading(true);
    axios
      .get(`${API}/packs`, { params: filter !== "alle" ? { category: filter } : {} })
      .then((res) => active && setPacks(res.data))
      .catch(() => active && setPacks([]))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [filter]);

  return (
    <section id="vault" data-testid="vault" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e2ff00] mb-4">Der Tresor</div>
            <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tight leading-[0.95]">
              Alle OG Packs
            </h2>
            <p className="mt-4 max-w-md text-[#8b8b93]">
              Entdecke unsere komplette Sammlung der seltensten OG Accounts. Verifiziert, Full Access, sofort geliefert.
            </p>
          </div>

          <div data-testid="vault-filters" className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                data-testid={`filter-${f.key}`}
                onClick={() => setFilter(f.key)}
                className={`font-mono text-xs uppercase tracking-[0.15em] px-4 py-2.5 rounded-full border transition-colors ${
                  filter === f.key
                    ? "bg-[#e2ff00] text-black border-[#e2ff00]"
                    : "text-[#8b8b93] border-white/15 hover:border-white/40 hover:text-white"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="grid place-items-center py-32 text-[#8b8b93]">
            <Loader2 className="animate-spin" />
          </div>
        ) : packs.length === 0 ? (
          <div data-testid="vault-empty" className="text-center py-32 font-mono text-[#8b8b93]">
            Keine Packs in dieser Kategorie.
          </div>
        ) : (
          <motion.div layout className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {packs.map((p, i) => (
              <SkinCard key={p.id} pack={p} index={i} />
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
};
